import {
  createCrashReporter,
  createOnCatch,
  createTransportProbe,
} from './crashReporter';
import { logger } from './logger';

/**
 * App-wired crash reporting. `import.meta` lives ONLY here so that
 * crashReporter.ts stays loadable under ts-jest (CJS) — same split as
 * beforeSend.ts (pure) vs logger.ts (wiring).
 *
 * Statically imported from main.tsx so it ships in the entry bundle: it
 * must be available even when a lazily-loaded chunk failed to fetch —
 * which is precisely one of the crashes it exists to report.
 */
export const sendCrashReport = createCrashReporter({
  release: import.meta.env.VITE_APP_VERSION || 'development-local',
  mode: import.meta.env.MODE || 'development',
});

/** The router's defaultOnCatch (see createOnCatch for what and why). */
export const onRouterCatch = createOnCatch(
  sendCrashReport,
  logger.captureException,
);

/**
 * Degraded-mode counter. All logic (and its documentation) lives in
 * createTransportProbe — deliberately in crashReporter.ts, which is the
 * testable half of this split: it is the number we will read to decide
 * whether the incident is over, so it is the last thing that should be
 * untestable. Only the reporter binding belongs here.
 *
 * See main.tsx for why the call is deferred rather than run at render.
 */
export const reportTmaTransportOnce = createTransportProbe(sendCrashReport);
